import { lazy } from 'react';

export const BaseDomainList = lazy(() => import('./page-list'));

